import { createFileRoute, redirect } from "@tanstack/react-router";
import { slugifyTag } from "@/lib/tags";

export const Route = createFileRoute("/blog/tag/$tag")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/blog/tags",
      hash: slugifyTag(params.tag),
      statusCode: 301,
    });
  },
});